// import './network-error.scss';

export { default } from './NetworkError';
export { default as template } from './network-error.tpl';
